module.exports = __webpack_public_path__ + "static/media/55_000029.04ee7d35.jpg";